export default "__VITE_ASSET__i0Cv8adC__"